import InvoiceView from './InvoiceView'

export default InvoiceView
